module.exports = __webpack_public_path__ + "static/media/cloudy-day-1.80a5d865.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/cloudy-day-1.svg
// module id = 510
// module chunks = 0